
  <button mat-menu-item class="message-sender-button" [matMenuTriggerFor]="emptymenu">
    <mat-icon title="Message sender" [svgIcon]="icons.SEND"></mat-icon>
  </button>

  <mat-menu #emptymenu="matMenu"  [hasBackdrop]="false" class="message-sender-menu" (click)="$event.stopPropagation()">
    <div cdkTrapFocus cdkTrapFocusAutoCapture="true" (keydown.tab)="$event.stopPropagation()" (keydown.shift.tab)="$event.stopPropagation()">
      <div class="message-sender-header" (click)="$event.stopPropagation()">
        <span class="title">Message Sender</span>
      </div>

      <div class="message-sender-form" (click)="$event.stopPropagation()">
        <label for="message-select">Message type</label>
        <select id="message-select" [(ngModel)]="selectedValue" (click)="$event.stopPropagation()">
          <optgroup label="Incoming (Source = Portal)">
            <!--Needs message config-->
            <option>userStateChange</option>
            <option>tenantChange</option>
            <option>appAction</option>
            <!--Doesn't need message config
            <option>activate</option>
            <option>passivate</option>
            <option>keepAlive</option>
            <option>getPageUrl</option>
            -->
          </optgroup>
          <optgroup label="Outgoing (Destination = Portal)">
            <option>appAction</option>
            <option>createDeepLink</option>
            <option>login</option>
            <option>registerMenuItems</option>
            <option>iframeMetadata</option>
          </optgroup>
          <optgroup label="Portal (Internal)">
            <option>channel</option>
          </optgroup>
        </select>

        @if (selectedValue === 'appAction' || selectedValue === 'createDeepLink' || selectedValue === 'login' || selectedValue === 'registerMenuItems' || selectedValue === 'iframeMetadata') {
          <div>
            <label for="message-source">Source</label>
            <select id="message-source" (click)="$event.stopPropagation()">
              @for (app of applications | keyvalue; track app.key) {
                <option>
                  {{app.value}}
                </option>
              }
            </select>
          </div>
        } @else {
          @if (selectedValue !== 'createDeepLink' && selectedValue !== 'channel') {
            <div>
              <label for="message-destination">Destination</label>
              <select id="message-destination" (click)="$event.stopPropagation()">
                @for (app of applications | keyvalue; track app.key) {
                  <option>
                    {{app.value}}
                  </option>
                }
              </select>
            </div>
          }
        }

        @if (selectedValue === 'userStateChange') {
          <div>
            <label for="userStateChange-event">Type</label>
            <select id="userStateChange-event">
              <option>LOGIN</option>
              <option>LOGOUT</option>
              <option>LOGIN_CANCELED</option>
            </select>
            <label for="userStateChange-authCode">authCode</label>
            <textarea id="userStateChange-authCode" placeholder="Leave blank for default values"></textarea>
          </div>
        }

        @if (selectedValue === 'channel') {
          <div>
            <label for="channel-event">EventType</label>
            <select id="channel-event">
              <option>LOGIN</option>
              <option>LOGOUT</option>
              <option>SITE_SWITCH</option>
              <option>ERROR</option>
            </select>
          </div>
        }

        @if (selectedValue === 'tenantChange') {
          <div>
            <label for="tenantChange-appId">appId</label>
            <textarea id="tenantChange-appId" placeholder="Leave blank for default values"></textarea>
            <label for="tenantChange-siteGuid">siteGuid</label>
            <textarea id="tenantChange-siteGuid" placeholder="Leave blank for default values"></textarea>
            <label for="tenantChange-authCode">authCode</label>
            <textarea id="tenantChange-authCode" placeholder="Leave blank for default values"></textarea>

          </div>
        }

        @if (selectedValue === 'appAction') {
          <div>
            <label for="appAction-destination">AppAction destination</label>
            <select id="appAction-destination" (click)="$event.stopPropagation()">
              @for (app of applications | keyvalue; track app.key) {
                <option>
                  {{app.value}}
                </option>
              }
            </select>
            <label for="appAction-route">Route (optional)</label>
            <textarea id="appAction-route" placeholder=""></textarea>
            <label for="appAction-params">Params</label>
              <textarea id="appAction-params"></textarea>
          </div>
        }

        @if (selectedValue === 'createDeepLink') {
          <div>
            <label for="deepLink-route">Route</label>
            <textarea id="deepLink-route"></textarea>
            <label for="deepLink-params">Params</label>
              <textarea id="deepLink-params"></textarea>
          </div>
        }

        @if (selectedValue === 'registerMenuItems') {
          <div (keydown)="$event.stopPropagation()">
            <label for="menu-items">Menu[]</label>
            <textarea id="menu-items"></textarea>
          </div>
        }

        @if (selectedValue === 'login') {
          <div>
            <label for="login-continuationState">continuation state</label>
            <textarea id="login-continuationState"></textarea>
          </div>
        }

        @if (selectedValue === 'iframeMetadata') {
          <div>
            <label for="iframe-metadata-width">Width</label>
            <textarea id="iframe-metadata-width" placeholder="e.g., 800px or 80%"></textarea>
            <label for="iframe-metadata-height">Height</label>
            <textarea id="iframe-metadata-height" placeholder="e.g., 600px or 60%"></textarea>
          </div>
        }

        <button (click)="sendMessage()">Send</button>
      </div>
    </div>
  </mat-menu>
